/* Product markers ("spots" on a lifestyle image).
   - Desktop with a mouse: hovering a spot opens its product card, leaving it closes
     the card after a short grace period so the pointer can travel onto the card.
   - Touch / small screens: tapping a spot shows the product in the card strip under
     the image (vendor behaviour, unchanged).
   - Auto popup (section setting): while nobody is interacting, the spots open one
     after another. Any hover, tap or click hands control to the user; on desktop
     the cycle resumes once the mouse leaves the image. */
(function () {
  const HOVER = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  const productMarkers = (root) => {
    const sections = root ? [root] : Array.from(document.querySelectorAll('.product-markers'));
    sections.forEach((section) => {
      if (section.dataset.markersReady === 'true') return;
      section.dataset.markersReady = 'true';

      const items = Array.from(section.querySelectorAll('.js-product-markers__item'));
      if (!items.length) return;
      const image = section.querySelector('.product-markers__markers');
      const mobileWrap = section.querySelector('.product-markers-for-mobile');
      const mobileCards = Array.from(section.querySelectorAll('.product-markers-for-mobile .product-markers__item-inner'));

      const isInteractive = (target) => target.closest('.quick-add') || target.closest('.product-parameters');

      const open = (item) => {
        items.forEach((el) => el.classList.toggle('active', el === item));
        mobileCards.forEach((card) => card.classList.toggle('active', card.dataset.index === item.dataset.index));
        if (mobileWrap) mobileWrap.classList.add('active');
      };
      const closeAll = () => items.forEach((el) => el.classList.remove('active'));

      /* ---- auto popup cycle ---- */
      const auto = section.dataset.autoPopup === 'true' && !REDUCED.matches;
      const interval = Math.max(1500, Number(section.dataset.autoInterval || 4) * 1000);
      let timer = null;
      let cursor = -1;
      let userTookOver = false;
      let visible = false;

      const step = () => {
        cursor = (cursor + 1) % items.length;
        open(items[cursor]);
      };
      const start = (immediate) => {
        if (!auto || timer || userTookOver || !visible) return;
        if (immediate) step();
        timer = setInterval(step, interval);
      };
      const stop = () => {
        if (timer) clearInterval(timer);
        timer = null;
      };

      if (auto && 'IntersectionObserver' in window) {
        new IntersectionObserver(
          (entries) => {
            visible = entries.some((e) => e.isIntersecting);
            visible ? start(true) : stop();
          },
          { threshold: 0.35 }
        ).observe(section);
      } else if (auto) {
        visible = true;
        start(true);
      }

      /* ---- hover (desktop) ---- */
      let leaveTimer = null;
      items.forEach((item) => {
        item.addEventListener('mouseenter', () => {
          if (!HOVER.matches) return;
          clearTimeout(leaveTimer);
          stop();
          open(item);
          cursor = items.indexOf(item);
        });
        item.addEventListener('mouseleave', () => {
          if (!HOVER.matches) return;
          leaveTimer = setTimeout(() => item.classList.remove('active'), 250);
        });
      });
      if (image) {
        image.addEventListener('mouseenter', () => HOVER.matches && stop());
        image.addEventListener('mouseleave', () => {
          if (!HOVER.matches) return;
          userTookOver = false;
          start();
        });
      }

      /* ---- tap / click (touch and keyboard) ---- */
      items.forEach((item) => {
        item.addEventListener('click', (e) => {
          if (isInteractive(e.target)) return;
          stop();
          userTookOver = true;
          if (HOVER.matches) return; // hover already handles desktop
          if (item.classList.contains('active')) {
            item.classList.remove('active');
          } else {
            open(item);
            // the card strip sits above the image on small screens: bring it into view
            const card = mobileCards.find((c) => c.dataset.index === item.dataset.index);
            if (card) {
              // keep clear of the sticky header (marquee + nav)
              const header = document.querySelector('ohoh-header') || document.querySelector('.shopify-section-group-header-group');
              const safeTop = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
              const r = card.getBoundingClientRect();
              if (r.top < safeTop + 12) {
                window.scrollBy({ top: r.top - safeTop - 12, behavior: 'smooth' });
              } else if (r.bottom > window.innerHeight) {
                window.scrollBy({ top: r.bottom - window.innerHeight + 12, behavior: 'smooth' });
              }
            }
          }
        });
      });
      section.addEventListener('touchstart', () => { stop(); userTookOver = true; }, { passive: true });
    });
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('.js-product-markers__item') || e.target.closest('.product-parameters')) return;
    document.querySelectorAll('.js-product-markers__item.active').forEach((m) => m.classList.remove('active'));
  });

  productMarkers();

  document.addEventListener('shopify:section:load', (event) => {
    const root = (event.detail?.section || event.target)?.querySelector?.('.product-markers');
    productMarkers(root || undefined);
  });
})();
